// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iconContainer[data-v-e224a7cc] {\n  display: flex;\n  flex-direction: row;\n}\n.dragGrouping[data-v-e224a7cc] {\n  color: var(--v-grey-base);\n  cursor: pointer;\n  margin-right: 10px;\n  margin-top: 3px;\n}\n.dragGrouping[data-v-e224a7cc]:hover {\n  color: var(--v-primary-base);\n}", ""]);
// Exports
module.exports = exports;
